/*! California Classic — Custom Putter Configurator v1
 * SVG stamp editor on real putter photos, live pricing from Shopify variants,
 * cart integration via /cart/add.js with full design JSON in line-item properties.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* Pure helpers (also exercised by tests via window.CCP.core)          */
  /* ------------------------------------------------------------------ */
  var core = {};

  core.formatMoney = function (cents, format) {
    var fmt = format || '${{amount}}';
    var n = Math.round(cents);
    function withDelims(num, decimals) {
      var parts = (num / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return withDelims(n, 0);
      if (key === 'amount_with_comma_separator') return withDelims(n, 2).replace('.', ',');
      return withDelims(n, 2);
    });
  };

  /* Single pricing function. All values are integer cents. The variant price
     comes from Shopify (which validates it again at checkout). */
  core.price = function (data, cfg) {
    var xo = data.extraOptions || [];
    var sv = data.surchargeView || 'sole';
    var needs = xo.length > 1 && (cfg.stamps || []).some(function (s) { return s.view === sv; });
    var off = xo.length ? xo[0] : null, on = xo.length ? xo[needs ? 1 : 0] : null;
    var base = core.findVariant(data, cfg.head, data.shaftOptions[0], off);
    var mid = core.findVariant(data, cfg.head, cfg.shaft, off);
    var v = core.findVariant(data, cfg.head, cfg.shaft, on);
    if (!v || !base || !mid) return null;
    return {
      variant: v,
      baseCents: base.price,
      shaftSurchargeCents: mid.price - base.price,
      stampSurchargeCents: v.price - mid.price,
      totalCents: v.price
    };
  };

  core.findVariant = function (data, head, shaft, extra) {
    for (var i = 0; i < data.product.variants.length; i++) {
      var v = data.product.variants[i];
      if (v.option1 === head && v.option2 === shaft && (extra == null || v.option3 === extra)) return v;
    }
    return null;
  };

  core.lengths = function () {
    var out = [];
    for (var l = 32; l <= 38.0001; l += 0.5) out.push(Math.round(l * 10) / 10);
    return out;
  };

  core.fmtLength = function (l) { return (l % 1 === 0 ? l.toFixed(0) : l.toFixed(1)) + '"'; };

  core.fraction = function (inches) {
    var n = Math.round(inches * 32); // nearest 1/32"
    if (n <= 0) return '0"';
    var whole = Math.floor(n / 32), rem = n % 32, den = 32;
    while (rem && rem % 2 === 0) { rem /= 2; den /= 2; }
    return (whole ? whole + (rem ? ' ' : '') : '') + (rem ? rem + '/' + den : '') + '"';
  };

  core.mm = function (inches) {
    var v = Math.round(inches * 254) / 10; // inches -> mm, 0.1 mm
    return (v % 1 === 0 ? v.toFixed(0) : v.toFixed(1)) + 'mm';
  };

  core.hash = function (str) {
    var h = 0x811c9dc5;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
    return ('00000000' + h.toString(16)).slice(-8).toUpperCase();
  };

  /* Rotated rectangle corners (px) */
  core.corners = function (cx, cy, w, h, deg) {
    var r = deg * Math.PI / 180, c = Math.cos(r), s = Math.sin(r);
    return [[-w / 2, -h / 2], [w / 2, -h / 2], [w / 2, h / 2], [-w / 2, h / 2]].map(function (p) {
      return [cx + p[0] * c - p[1] * s, cy + p[0] * s + p[1] * c];
    });
  };

  core.pointInPoly = function (pt, poly) {
    var inside = false;
    for (var i = 0, j = poly.length - 1; i < poly.length; j = i++) {
      var xi = poly[i][0], yi = poly[i][1], xj = poly[j][0], yj = poly[j][1];
      if (((yi > pt[1]) !== (yj > pt[1])) && (pt[0] < (xj - xi) * (pt[1] - yi) / (yj - yi) + xi)) inside = !inside;
    }
    return inside;
  };

  core.zonePoly = function (z) {
    if (z.points && z.points.length >= 3) return z.points;
    var r = z.rect; return [[r[0], r[1]], [r[2], r[1]], [r[2], r[3]], [r[0], r[3]]];
  };

  /* Find the zone fully containing the (normalized) corner set. */
  core.zoneFor = function (cornersNorm, zones, allowed) {
    for (var i = 0; i < zones.length; i++) {
      var z = zones[i];
      if (allowed && allowed.length && allowed.indexOf(z.id) === -1) continue;
      var poly = core.zonePoly(z), ok = true;
      for (var k = 0; k < cornersNorm.length; k++) { if (!core.pointInPoly(cornersNorm[k], poly)) { ok = false; break; } }
      if (ok) return z;
    }
    return null;
  };

  window.CCP = window.CCP || {};
  window.CCP.core = core;

  /* ------------------------------------------------------------------ */
  /* App                                                                 */
  /* ------------------------------------------------------------------ */
  var root = document.querySelector('[data-ccp-root]');
  if (!root) return;
  var dataEl = root.querySelector('[data-ccp-data]');
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { root.querySelector('[data-ccp-fatal]').hidden = false; return; }

  var SVGNS = 'http://www.w3.org/2000/svg';
  var STORE_KEY = 'ccp:design:v1';
  var CONFIG_VERSION = 1;
  var lengths = core.lengths();

  /* Placement zones + calibration are edited by the owner as JSON in the theme editor.
     A malformed value must never break the page: fall back to "no stampable areas". */
  var zoneCfg = {};
  try { zoneCfg = JSON.parse(data.zonesRaw || '{}') || {}; } catch (e) { zoneCfg = {}; if (window.console) console.warn('[CCP] Stamp zone JSON is invalid; no stampable areas are active.', e); }
  (data.views || []).forEach(function (v) {
    var zc = zoneCfg[v.id] || {};
    v.zones = (zc.zones || []).filter(function (z) { return z && z.id && ((z.rect && z.rect.length === 4) || (z.points && z.points.length >= 3)); });
    v.note = zc.note || '';
  });
  data.views = (data.views || []).filter(function (v) { return v.src; });
  var viewById = {}; data.views.forEach(function (v) { viewById[v.id] = v; });
  var libById = {};
  (data.stamps || []).forEach(function (s) { s.kind = 'icon'; libById[s.id] = s; });
  (data.letterSets || []).forEach(function (s) { s.kind = 'text'; libById[s.id] = s; });

  var state = {
    head: data.headOptions[0],
    shaft: data.shaftOptions[0],
    length: null,
    view: data.views.length ? data.views[0].id : null,
    stamps: [],
    selected: null,
    preview: false,
    showZones: false,
    color: 'White'
  };
  var history = [], future = [];
  var uidSeq = 1;
  function uid() { return 's' + Date.now().toString(36) + (uidSeq++); }

  /* ---------- DOM refs ---------- */
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  var stage = $('[data-ccp-stage]');
  var svg = $('[data-ccp-svg]');
  var gImage = svg.querySelector('[data-layer="image"]');
  var gZones = svg.querySelector('[data-layer="zones"]');
  var gStamps = svg.querySelector('[data-layer="stamps"]');
  var gUi = svg.querySelector('[data-layer="ui"]');
  var liveEl = $('[data-ccp-live]');
  var measureCtx = document.createElement('canvas').getContext('2d');

  function announce(msg) { if (liveEl) { liveEl.textContent = ''; setTimeout(function () { liveEl.textContent = msg; }, 30); } }
  function soleExtraCents() {
    var xo = data.extraOptions || []; if (xo.length < 2) return 0;
    var a = core.findVariant(data, state.head, state.shaft, xo[0]), b = core.findVariant(data, state.head, state.shaft, xo[1]);
    return a && b ? b.price - a.price : 0;
  }
  var COLORS = [['Red', '#d62828'], ['Orange', '#f77f00'], ['Yellow', '#fcd116'], ['Green', '#2a9d3f'], ['Tiffany Blue', '#0abab5'], ['Blue', '#1e6fdc'], ['Dark Blue', '#0b2463'], ['Pink', '#f472b6'], ['Purple', '#7b3fbf'], ['White', '#ffffff'], ['Black', '#111111']];
  var colorByName = {}; COLORS.forEach(function (c, i) { colorByName[c[0]] = { name: c[0], hex: c[1], i: i }; });
  function stampColor(st) { return colorByName[st && st.color] || colorByName.White; }
  function hexRgb(hex) { var h = hex.replace('#', ''); var n = parseInt(h, 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
  function isDark(hex) { var c = hexRgb(hex); return (0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]) < 110; }
  function toast(msg) { if (window.Auric && window.Auric.showToast) window.Auric.showToast(msg); else announce(msg); }

  /* ---------- geometry ---------- */
  function fontFor(set) { return set.font === 'large' ? data.fonts.large : data.fonts.standard; }
  function fontWeightFor(set) { return set.font === 'large' ? data.fonts.largeWeight : data.fonts.standardWeight; }

  function geom(st) {
    var view = viewById[st.view]; var lib = libById[st.ref];
    if (!view || !lib) return null;
    var hPx = st.sizeIn * view.ppi, wPx;
    if (lib.kind === 'icon') {
      wPx = hPx * (lib.aspect || 1);
    } else {
      var fs = hPx / data.fonts.capRatio;
      measureCtx.font = fontWeightFor(lib) + ' ' + fs + 'px ' + fontFor(lib);
      var spacing = fs * 0.06;
      var t = st.text || ' ';
      wPx = measureCtx.measureText(t).width + spacing * Math.max(0, t.length - 1);
      wPx = Math.max(wPx, hPx * 0.4);
    }
    var cx = st.x * view.w, cy = st.y * view.h;
    var corners = core.corners(cx, cy, wPx, hPx, st.rot || 0);
    var norm = corners.map(function (p) { return [p[0] / view.w, p[1] / view.h]; });
    return { view: view, lib: lib, w: wPx, h: hPx, cx: cx, cy: cy, corners: corners, norm: norm };
  }

  function validate(st) {
    var g = geom(st); if (!g) { st.zone = null; st.invalid = true; return; }
    var z = core.zoneFor(g.norm, g.view.zones || [], g.lib.zones);
    st.zone = z ? z.id : null;
    st.zoneName = z ? z.name : null;
    st.invalid = !z || (g.lib.kind === 'text' && !String(st.text || '').trim());
  }

  function validateAll() { state.stamps.forEach(validate); }

  /* ---------- history ---------- */
  function snapshot() { return JSON.stringify(state.stamps.map(cleanStamp)); }
  function cleanStamp(s) { return { uid: s.uid, ref: s.ref, view: s.view, x: s.x, y: s.y, sizeIn: s.sizeIn, rot: s.rot, text: s.text, color: s.color }; }
  var lastSnap = '[]';
  function commit() {
    var snap = snapshot();
    if (snap === lastSnap) return;
    history.push(lastSnap); if (history.length > 100) history.shift();
    future = []; lastSnap = snap;
    validateAll(); persist(); renderAll();
  }
  function restore(snap) {
    state.stamps = JSON.parse(snap); lastSnap = snap;
    if (state.selected && !findStamp(state.selected)) state.selected = null;
    validateAll(); persist(); renderAll();
  }
  function undo() { if (!history.length) return; future.push(lastSnap); restore(history.pop()); announce('Undone'); }
  function redo() { if (!future.length) return; history.push(lastSnap); restore(future.pop()); announce('Redone'); }

  /* ---------- persistence (per-viewer convenience only) ---------- */
  function persist() {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify({ head: state.head, shaft: state.shaft, length: state.length, view: state.view, color: state.color, stamps: state.stamps.map(cleanStamp) }));
    } catch (e) { /* storage unavailable: design still works for this visit */ }
  }
  function loadPersisted() {
    try {
      var raw = localStorage.getItem(STORE_KEY); if (!raw) return;
      var d = JSON.parse(raw);
      if (data.headOptions.indexOf(d.head) > -1) state.head = d.head;
      if (data.shaftOptions.indexOf(d.shaft) > -1) state.shaft = d.shaft;
      if (lengths.indexOf(d.length) > -1) state.length = d.length;
      if (viewById[d.view]) state.view = d.view;
      if (colorByName[d.color]) state.color = d.color;
      state.stamps = (d.stamps || []).filter(function (s) { return libById[s.ref] && viewById[s.view]; });
      lastSnap = snapshot();
    } catch (e) { /* ignore corrupt storage */ }
  }

  /* ---------- stamps ---------- */
  function findStamp(id) { for (var i = 0; i < state.stamps.length; i++) if (state.stamps[i].uid === id) return state.stamps[i]; return null; }
  function selected() { return state.selected ? findStamp(state.selected) : null; }
  function clampSize(lib, v) { return Math.min(lib.maxIn, Math.max(lib.minIn, v)); }

  function defaultPoint(lib, viewId) {
    var view = viewById[viewId];
    var zones = (view.zones || []).filter(function (z) { return !lib.zones || !lib.zones.length || lib.zones.indexOf(z.id) > -1; });
    if (!zones.length) return null;
    // Prefer an empty-ish zone: pick the first zone with fewest stamps
    zones.sort(function (a, b) { return countIn(a.id, viewId) - countIn(b.id, viewId); });
    var poly = core.zonePoly(zones[0]);
    var cx = 0, cy = 0; poly.forEach(function (p) { cx += p[0]; cy += p[1]; });
    return { x: cx / poly.length, y: cy / poly.length };
  }
  function countIn(zoneId, viewId) { return state.stamps.filter(function (s) { return s.view === viewId && s.zone === zoneId; }).length; }

  function addStamp(libId, pt) {
    var lib = libById[libId], view = viewById[state.view];
    if (!lib || !view) return;
    if (!(view.zones || []).length) { toast(view.label + ' has no stampable area. Switch to another view to add stamps.'); return; }
    var p = pt || defaultPoint(lib, state.view);
    if (!p) { toast(lib.name + ' can’t be placed on the ' + view.label.toLowerCase() + ' view.'); return; }
    var st = { uid: uid(), ref: libId, view: state.view, x: p.x, y: p.y, sizeIn: lib.defaultIn, rot: 0, color: state.color };
    if (lib.kind === 'text') st.text = (lib.sampleText || 'CLASSIC').slice(0, lib.maxChars);
    state.stamps.push(st);
    state.selected = st.uid;
    validate(st);
    commit();
    if (st.view === (data.surchargeView || 'sole') && soleExtraCents() && state.stamps.filter(function (x) { return x.view === st.view; }).length === 1) toast(view.label + ' stamping adds ' + core.formatMoney(soleExtraCents(), data.moneyFormat));
    announce(lib.name + ' added' + (st.invalid ? ' — outside the stampable area, drag it into a highlighted area' : ''));
    if (lib.kind === 'text') { var inp = $('[data-ccp-sel-text]'); if (inp) { inp.focus(); inp.select(); } }
  }

  function removeSelected() {
    var s = selected(); if (!s) return;
    state.stamps = state.stamps.filter(function (x) { return x.uid !== s.uid; });
    state.selected = null; commit(); announce('Stamp deleted');
  }
  function duplicateSelected() {
    var s = selected(); if (!s) return;
    var c = JSON.parse(JSON.stringify(cleanStamp(s)));
    c.uid = uid(); c.x = Math.min(0.98, s.x + 0.025); c.y = Math.min(0.98, s.y + 0.01);
    state.stamps.push(c); state.selected = c.uid; commit(); announce('Stamp duplicated');
  }
  function bringToFront() {
    var s = selected(); if (!s) return;
    state.stamps = state.stamps.filter(function (x) { return x.uid !== s.uid; }); state.stamps.push(s); commit();
  }
  function sendToBack() {
    var s = selected(); if (!s) return;
    state.stamps = state.stamps.filter(function (x) { return x.uid !== s.uid; }); state.stamps.unshift(s); commit();
  }

  /* ---------- rendering: stage ---------- */
  function el(name, attrs, parent) {
    var n = document.createElementNS(SVGNS, name);
    for (var k in attrs) if (attrs[k] !== undefined && attrs[k] !== null) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function clear(n) { while (n.firstChild) n.removeChild(n.firstChild); }

  function unitsPerScreenPx() {
    var view = viewById[state.view]; var r = svg.getBoundingClientRect();
    return r.width ? view.w / r.width : 1;
  }

  var renderedView = null;
  function renderStage() {
    var view = viewById[state.view];
    if (!view) return;
    if (renderedView !== view.id) {
      svg.setAttribute('viewBox', '0 0 ' + view.w + ' ' + view.h);
      stage.style.aspectRatio = view.w + ' / ' + view.h;
      clear(gImage);
      stage.classList.add('is-loading');
      var img = el('image', { href: view.src, x: 0, y: 0, width: view.w, height: view.h, preserveAspectRatio: 'xMidYMid slice' }, gImage);
      img.addEventListener('load', function () { stage.classList.remove('is-loading'); stage.classList.remove('has-error'); });
      img.addEventListener('error', function () { stage.classList.remove('is-loading'); stage.classList.add('has-error'); });
      renderedView = view.id;
      $all('[data-ccp-filter-offset]').forEach(function (hl) { hl.setAttribute('dy', Math.max(1, view.ppi * 0.0045).toFixed(2)); });
    }
    // zones
    clear(gZones);
    var sel = selected();
    var showZones = !state.preview && (state.showZones || dragging || (sel && sel.view === view.id));
    if (showZones) {
      var allowed = sel ? libById[sel.ref].zones : null;
      (view.zones || []).forEach(function (z) {
        var poly = core.zonePoly(z).map(function (p) { return (p[0] * view.w).toFixed(1) + ',' + (p[1] * view.h).toFixed(1); }).join(' ');
        var dim = allowed && allowed.length && allowed.indexOf(z.id) === -1;
        el('polygon', { points: poly, 'class': 'ccp-zone' + (dim ? ' is-dim' : ''), 'vector-effect': 'non-scaling-stroke' }, gZones);
      });
    }
    // stamps
    clear(gStamps);
    state.stamps.forEach(function (st) {
      if (st.view !== view.id) return;
      var g = geom(st); if (!g) return;
      var outer = el('g', { transform: 'translate(' + g.cx.toFixed(2) + ' ' + g.cy.toFixed(2) + ') rotate(' + (st.rot || 0) + ')', 'class': 'ccp-stamp' + (st.invalid && !state.preview ? ' is-invalid' : ''), 'data-uid': st.uid }, gStamps);
      var grp = el('g', { filter: 'url(#ccp-ink-' + stampColor(st).i + ')' }, outer);
      if (g.lib.kind === 'icon') {
        el('image', { href: g.lib.src, x: (-g.w / 2).toFixed(2), y: (-g.h / 2).toFixed(2), width: g.w.toFixed(2), height: g.h.toFixed(2), preserveAspectRatio: 'none', 'data-uid': st.uid, opacity: data.settings.opacity }, grp);
      } else {
        var fs = g.h / data.fonts.capRatio;
        var t = el('text', { x: 0, y: (g.h / 2).toFixed(2), 'text-anchor': 'middle', 'font-size': fs.toFixed(2), 'font-family': fontFor(g.lib), 'font-weight': fontWeightFor(g.lib), 'letter-spacing': (fs * 0.06).toFixed(2), 'data-uid': st.uid, fill: '#000', opacity: data.settings.opacity }, grp);
        t.textContent = st.text || '';
      }
      // generous transparent hit area for touch
      var hitPad = 10 * unitsPerScreenPx();
      el('rect', { x: (-g.w / 2 - hitPad).toFixed(2), y: (-g.h / 2 - hitPad).toFixed(2), width: (g.w + hitPad * 2).toFixed(2), height: (g.h + hitPad * 2).toFixed(2), fill: 'transparent', 'data-uid': st.uid, 'class': 'ccp-hit' }, outer);
    });
    // selection UI
    clear(gUi);
    if (sel && sel.view === view.id && !state.preview) {
      var g2 = geom(sel); if (g2) {
        var u = unitsPerScreenPx();
        var pad = 6 * u, r = 9 * u;
        var ui = el('g', { transform: 'translate(' + g2.cx + ' ' + g2.cy + ') rotate(' + (sel.rot || 0) + ')' }, gUi);
        el('rect', { x: -g2.w / 2 - pad, y: -g2.h / 2 - pad, width: g2.w + pad * 2, height: g2.h + pad * 2, 'class': 'ccp-selbox' + (sel.invalid ? ' is-invalid' : ''), 'vector-effect': 'non-scaling-stroke', 'data-uid': sel.uid }, ui);
        var lb = libById[sel.ref];
        if (lb.maxIn - lb.minIn >= 0.001) el('circle', { cx: g2.w / 2 + pad, cy: g2.h / 2 + pad, r: r, 'class': 'ccp-handle', 'data-handle': 'resize', 'vector-effect': 'non-scaling-stroke' }, ui);
        if (libById[sel.ref].rotatable) {
          var top = -g2.h / 2 - pad;
          el('line', { x1: 0, y1: top, x2: 0, y2: top - 26 * u, 'class': 'ccp-sel-line', 'vector-effect': 'non-scaling-stroke' }, ui);
          el('circle', { cx: 0, cy: top - 26 * u, r: r, 'class': 'ccp-handle ccp-handle--rotate', 'data-handle': 'rotate', 'vector-effect': 'non-scaling-stroke' }, ui);
        }
      }
    }
    stage.classList.toggle('is-preview', state.preview);
    var empty = $('[data-ccp-stage-empty]');
    if (empty) empty.hidden = !!(view.zones && view.zones.length);
  }

  /* ---------- rendering: panels ---------- */
  function renderOptions() {
    $all('[data-ccp-head]').forEach(function (b) { var on = b.getAttribute('data-ccp-head') === state.head; b.setAttribute('aria-checked', on); b.classList.toggle('is-selected', on); });
    $all('[data-ccp-shaft]').forEach(function (b) { var on = b.getAttribute('data-ccp-shaft') === state.shaft; b.setAttribute('aria-checked', on); b.classList.toggle('is-selected', on); });
    $all('[data-ccp-length]').forEach(function (b) { var on = parseFloat(b.getAttribute('data-ccp-length')) === state.length; b.setAttribute('aria-checked', on); b.classList.toggle('is-selected', on); });
    var lsel = $('[data-ccp-length-select]'); if (lsel) lsel.value = state.length === null ? '' : String(state.length);
    var lout = $('[data-ccp-length-value]'); if (lout) lout.textContent = state.length === null ? 'Select a length' : core.fmtLength(state.length);
    $('[data-ccp-head-value]').textContent = state.head;
    $('[data-ccp-shaft-value]').textContent = state.shaft;
  }

  function renderViews() {
    $all('[data-ccp-view]').forEach(function (b) {
      var id = b.getAttribute('data-ccp-view'); var on = id === state.view;
      b.setAttribute('aria-selected', on); b.classList.toggle('is-active', on);
      var n = state.stamps.filter(function (s) { return s.view === id; }).length;
      var badge = b.querySelector('[data-ccp-view-count]'); if (badge) { badge.textContent = n; badge.hidden = !n; }
      var ex = b.querySelector('[data-ccp-view-extra]'), extra = id === (data.surchargeView || 'sole') ? soleExtraCents() : 0;
      if (extra && !ex) { ex = document.createElement('span'); ex.setAttribute('data-ccp-view-extra', ''); ex.className = 'ccp-view__extra'; b.appendChild(ex); }
      if (ex) { ex.hidden = !extra; ex.textContent = '+' + core.formatMoney(extra, data.moneyFormat).replace(/\.00$/, ''); }
    });
  }

  function renderToolbar() {
    var s = selected();
    $all('[data-ccp-needs-sel]').forEach(function (b) { b.disabled = !s; });
    $('[data-ccp-undo]').disabled = !history.length;
    $('[data-ccp-redo]').disabled = !future.length;
    $('[data-ccp-reset]').disabled = !state.stamps.length;
    var pv = $('[data-ccp-preview]'); pv.setAttribute('aria-pressed', state.preview); pv.textContent = state.preview ? 'Edit' : 'Preview';
    var zb = $('[data-ccp-zones]'); zb.setAttribute('aria-pressed', state.showZones);

    var panel = $('[data-ccp-sel-panel]');
    if (!s) { panel.hidden = true; return; }
    panel.hidden = false;
    var lib = libById[s.ref];
    $('[data-ccp-sel-name]').textContent = lib.kind === 'text' ? lib.name + ' letters' : lib.name;
    var where = viewById[s.view].label + (s.zoneName ? ' · ' + s.zoneName : '');
    var status = $('[data-ccp-sel-status]');
    status.textContent = s.invalid ? (lib.kind === 'text' && !String(s.text || '').trim() ? 'Enter your text' : 'Outside a stampable area — drag it into a highlighted area') : where;
    status.classList.toggle('is-error', !!s.invalid);
    var size = $('[data-ccp-sel-size]');
    var fixed = lib.maxIn - lib.minIn < 0.001;
    size.hidden = fixed;
    size.min = lib.minIn; size.max = lib.maxIn; size.step = 0.005; size.value = s.sizeIn;
    $('[data-ccp-sel-size-out]').textContent = core.mm(s.sizeIn) + ' ' + (lib.kind === 'text' ? 'letter height' : 'tall') + (fixed ? ' · fixed by this stamp set' : '');
    var rotWrap = $('[data-ccp-sel-rot-wrap]'); rotWrap.hidden = !lib.rotatable;
    var rot = $('[data-ccp-sel-rot]'); rot.value = s.rot || 0;
    $('[data-ccp-sel-rot-out]').textContent = Math.round(s.rot || 0) + '°';
    var sc = stampColor(s);
    $all('[data-ccp-color]').forEach(function (b) { var on = b.getAttribute('data-ccp-color') === sc.name; b.setAttribute('aria-checked', on); b.tabIndex = on ? 0 : -1; });
    var co = $('[data-ccp-sel-color-out]'); if (co) co.textContent = sc.name;
    var tw = $('[data-ccp-sel-text-wrap]'); tw.hidden = lib.kind !== 'text';
    if (lib.kind === 'text') {
      var inp = $('[data-ccp-sel-text]');
      if (document.activeElement !== inp) inp.value = s.text || '';
      inp.maxLength = lib.maxChars;
      $('[data-ccp-sel-text-count]').textContent = (s.text || '').length + '/' + lib.maxChars;
      var setSel = $('[data-ccp-sel-set]');
      setSel.value = lib.id;
    }
  }

  function stampLabel(s) {
    var lib = libById[s.ref];
    return lib.kind === 'text' ? '“' + (s.text || '') + '” · ' + lib.name : lib.name;
  }

  function renderList() {
    var list = $('[data-ccp-list]'); clear(list);
    var count = $('[data-ccp-stamp-count]'); if (count) count.textContent = state.stamps.length ? state.stamps.length + (state.stamps.length === 1 ? ' stamp' : ' stamps') : 'No stamps yet';
    if (!state.stamps.length) { var li0 = document.createElement('li'); li0.className = 'ccp-list__empty'; li0.textContent = 'Stamps are optional. Pick one below the photo to add it to your putter.'; list.appendChild(li0); return; }
    state.stamps.slice().reverse().forEach(function (s) {
      var li = document.createElement('li'); li.className = 'ccp-list__item' + (s.uid === state.selected ? ' is-selected' : '') + (s.invalid ? ' is-invalid' : '');
      var b = document.createElement('button'); b.type = 'button'; b.className = 'ccp-list__btn';
      b.innerHTML = '<span class="ccp-list__name"></span><span class="ccp-list__meta"></span>';
      b.querySelector('.ccp-list__name').textContent = stampLabel(s);
      b.querySelector('.ccp-list__meta').textContent = viewById[s.view].label + (s.zoneName ? ' · ' + s.zoneName : '') + ' · ' + core.mm(s.sizeIn) + (s.rot ? ' · ' + Math.round(s.rot) + '°' : '') + ' · ' + stampColor(s).name + (s.invalid ? ' · needs attention' : '');
      b.addEventListener('click', function () { state.selected = s.uid; state.view = s.view; state.preview = false; renderAll(); stage.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'center' }); });
      li.appendChild(b); list.appendChild(li);
    });
  }

  function renderPrice() {
    var p = core.price(data, state);
    $all('[data-ccp-price]').forEach(function (n) { n.textContent = p ? core.formatMoney(p.totalCents, data.moneyFormat) : '—'; });
    var bd = $('[data-ccp-breakdown]');
    if (bd && p) {
      bd.innerHTML = '';
      [[state.head + ' head', p.baseCents], [state.shaft + ' shaft', p.shaftSurchargeCents], ['Custom stamps', 0]].concat(p.stampSurchargeCents ? [[(viewById[data.surchargeView || 'sole'] || { label: 'Sole' }).label + ' stamping', p.stampSurchargeCents]] : []).forEach(function (r, i) {
        var row = document.createElement('div'); row.className = 'ccp-breakdown__row';
        var a = document.createElement('span'); a.textContent = r[0];
        var b = document.createElement('span'); b.textContent = i === 0 ? core.formatMoney(r[1], data.moneyFormat) : (r[1] ? '+' + core.formatMoney(r[1], data.moneyFormat) : 'Included');
        row.appendChild(a); row.appendChild(b); bd.appendChild(row);
      });
    }
  }

  function issues() {
    var out = [];
    if (state.length === null) out.push({ msg: 'Choose your shaft length', target: '[data-ccp-step="length"]' });
    var bad = state.stamps.filter(function (s) { return s.invalid; });
    if (bad.length) out.push({ msg: bad.length + (bad.length === 1 ? ' stamp needs' : ' stamps need') + ' attention (outside a stampable area or missing text)', target: '[data-ccp-stage]', uid: bad[0].uid });
    if (!data.variantsReady) out.push({ msg: 'Loading prices…', target: '[data-ccp-step="head"]' });
    else if (data.variantsFailed && state.stamps.some(function (s) { return s.view === (data.surchargeView || 'sole'); })) out.push({ msg: 'Prices could not load. Please refresh the page.', target: '[data-ccp-step="head"]' });
    if (!core.price(data, state)) out.push({ msg: 'This combination is unavailable', target: '[data-ccp-step="head"]' });
    return out;
  }

  function renderSummary() {
    var dl = $('[data-ccp-summary]'); if (!dl) return;
    var p = core.price(data, state);
    var rows = [['Head', state.head], ['Shaft', state.shaft], ['Length', state.length === null ? 'Not selected' : core.fmtLength(state.length)], ['Stamps', state.stamps.length ? String(state.stamps.length) : 'None']];
    if (p && p.stampSurchargeCents) rows.push([(viewById[data.surchargeView || 'sole'] || { label: 'Sole' }).label + ' stamping', '+' + core.formatMoney(p.stampSurchargeCents, data.moneyFormat)]);
    dl.innerHTML = '';
    rows.forEach(function (r) { var dt = document.createElement('dt'); dt.textContent = r[0]; var dd = document.createElement('dd'); dd.textContent = r[1]; dl.appendChild(dt); dl.appendChild(dd); });
    var tb = $('[data-ccp-summary-stamps]'); clear(tb);
    state.stamps.forEach(function (s, i) {
      var tr = document.createElement('tr');
      var g = geom(s);
      [stampLabel(s) + ' · ' + stampColor(s).name, viewById[s.view].label + (s.zoneName ? ' · ' + s.zoneName : ' · outside area'), core.mm(s.sizeIn) + ' × ' + core.mm(g ? g.w / g.view.ppi : 0), Math.round(s.rot || 0) + '°', (s.x * 100).toFixed(1) + '%, ' + (s.y * 100).toFixed(1) + '%', String(i + 1)].forEach(function (v) { var td = document.createElement('td'); td.textContent = v; tr.appendChild(td); });
      tb.appendChild(tr);
    });
    $('[data-ccp-summary-table]').hidden = !state.stamps.length;
    var iss = issues(); var box = $('[data-ccp-issues]'); clear(box);
    iss.forEach(function (it) { var li = document.createElement('li'); li.textContent = it.msg; box.appendChild(li); });
    box.hidden = !iss.length;
    $all('[data-ccp-add]').forEach(function (b) { b.setAttribute('aria-disabled', iss.length ? 'true' : 'false'); });
    var stat = $('[data-ccp-status]'); if (stat) stat.textContent = iss.length ? iss[0].msg : 'Ready to add to cart';
  }

  function renderAll() {
    renderOptions(); renderViews(); renderStage(); renderToolbar(); renderList(); renderPrice(); renderSummary();
  }

  /* ---------- library ---------- */
  function buildLibrary() {
    var tabs = $('[data-ccp-lib-tabs]'), grid = $('[data-ccp-lib-grid]');
    var cats = [];
    (data.stamps || []).forEach(function (s) { if (cats.indexOf(s.category) === -1) cats.push(s.category); });
    if ((data.letterSets || []).length) cats.push('Letters & Numbers');
    var current = cats[0];
    function draw() {
      clear(tabs); clear(grid);
      cats.forEach(function (c) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'ccp-tab' + (c === current ? ' is-active' : ''); b.setAttribute('role', 'tab'); b.setAttribute('aria-selected', c === current); b.textContent = c;
        b.addEventListener('click', function () { current = c; draw(); }); tabs.appendChild(b);
      });
      var items = current === 'Letters & Numbers' ? data.letterSets : data.stamps.filter(function (s) { return s.category === current; });
      items.forEach(function (s) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'ccp-tile' + (s.kind === 'text' ? ' ccp-tile--text' : '');
        b.setAttribute('data-lib', s.id);
        b.setAttribute('aria-label', 'Add ' + s.name + (s.kind === 'text' ? ' letters' : ' stamp'));
        var fig = document.createElement('span'); fig.className = 'ccp-tile__art';
        var img = document.createElement('img'); img.src = s.kind === 'text' ? s.swatch : s.thumb; img.alt = ''; img.loading = 'lazy'; img.draggable = false;
        if (img.src) fig.appendChild(img);
        var nm = document.createElement('span'); nm.className = 'ccp-tile__name'; nm.textContent = s.name;
        var meta = document.createElement('span'); meta.className = 'ccp-tile__meta'; meta.textContent = s.kind === 'text' ? core.mm(s.defaultIn) + ' letters' : core.mm(s.defaultIn);
        b.appendChild(fig); b.appendChild(nm); b.appendChild(meta);
        bindTile(b, s.id);
        grid.appendChild(b);
      });
    }
    draw();
    // letter set <select> in selection panel
    var setSel = $('[data-ccp-sel-set]'); clear(setSel);
    (data.letterSets || []).forEach(function (s) { var o = document.createElement('option'); o.value = s.id; o.textContent = s.name; setSel.appendChild(o); });
  }

  var ghost = null;
  function bindTile(tile, libId) {
    var start = null, moved = false;
    tile.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return; // touch: tap-to-add
      start = { x: e.clientX, y: e.clientY }; moved = false;
      tile.setPointerCapture(e.pointerId);
    });
    tile.addEventListener('pointermove', function (e) {
      if (!start) return;
      if (!moved && Math.hypot(e.clientX - start.x, e.clientY - start.y) > 6) {
        moved = true; ghost = tile.querySelector('img') ? tile.querySelector('img').cloneNode() : document.createElement('span');
        ghost.className = 'ccp-ghost'; document.body.appendChild(ghost); dragging = true; renderStage();
      }
      if (moved && ghost) { ghost.style.left = e.clientX + 'px'; ghost.style.top = e.clientY + 'px'; stage.classList.toggle('is-drop', overStage(e)); }
    });
    tile.addEventListener('pointerup', function (e) {
      if (!start) return;
      var wasMoved = moved; start = null; moved = false;
      if (ghost) { ghost.remove(); ghost = null; }
      dragging = false; stage.classList.remove('is-drop');
      if (wasMoved) {
        if (overStage(e)) { var p = svgPoint(e); var v = viewById[state.view]; addStamp(libId, { x: p.x / v.w, y: p.y / v.h }); }
        else renderStage();
        tile.dataset.suppressClick = '1';
      }
    });
    tile.addEventListener('pointercancel', function () { start = null; moved = false; if (ghost) { ghost.remove(); ghost = null; } dragging = false; });
    tile.addEventListener('click', function () {
      if (tile.dataset.suppressClick) { delete tile.dataset.suppressClick; return; }
      state.preview = false; addStamp(libId);
    });
  }
  function overStage(e) { var r = stage.getBoundingClientRect(); return e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom; }

  /* ---------- stage interaction ---------- */
  var drag = null, dragging = false, rafPending = false;
  function svgPoint(e) {
    var pt = svg.createSVGPoint(); pt.x = e.clientX; pt.y = e.clientY;
    var m = svg.getScreenCTM(); return m ? pt.matrixTransform(m.inverse()) : { x: 0, y: 0 };
  }
  function schedule() { if (rafPending) return; rafPending = true; requestAnimationFrame(function () { rafPending = false; renderStage(); renderToolbar(); }); }

  svg.addEventListener('pointerdown', function (e) {
    if (state.preview) return;
    var t = e.target; var handle = t.getAttribute && t.getAttribute('data-handle');
    var id = t.getAttribute && t.getAttribute('data-uid');
    var s = handle ? selected() : (id ? findStamp(id) : null);
    if (!s) { if (state.selected) { state.selected = null; renderAll(); } return; }
    e.preventDefault();
    svg.setPointerCapture(e.pointerId);
    state.selected = s.uid;
    var p = svgPoint(e), g = geom(s);
    drag = { mode: handle || 'move', uid: s.uid, sx: p.x, sy: p.y, ox: s.x, oy: s.y, osize: s.sizeIn, orot: s.rot || 0, cx: g.cx, cy: g.cy, d0: Math.hypot(p.x - g.cx, p.y - g.cy) || 1, a0: Math.atan2(p.y - g.cy, p.x - g.cx) };
    dragging = true;
    svg.focus({ preventScroll: true });
    renderAll();
  });
  svg.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var s = findStamp(drag.uid); if (!s) return;
    var p = svgPoint(e), v = viewById[s.view], lib = libById[s.ref];
    if (drag.mode === 'move') {
      s.x = Math.min(1, Math.max(0, drag.ox + (p.x - drag.sx) / v.w));
      s.y = Math.min(1, Math.max(0, drag.oy + (p.y - drag.sy) / v.h));
    } else if (drag.mode === 'resize') {
      var d = Math.hypot(p.x - drag.cx, p.y - drag.cy);
      s.sizeIn = clampSize(lib, drag.osize * d / drag.d0);
    } else if (drag.mode === 'rotate') {
      var a = Math.atan2(p.y - drag.cy, p.x - drag.cx) * 180 / Math.PI + 90;
      if (!e.shiftKey) a = Math.round(a / 5) * 5; // gentle snapping; hold Shift for free rotation
      s.rot = ((Math.round(a) % 360) + 360) % 360; if (s.rot > 180) s.rot -= 360;
    }
    validate(s);
    schedule();
  });
  function endDrag() { if (!drag) return; drag = null; dragging = false; commit(); renderAll(); }
  svg.addEventListener('pointerup', endDrag);
  svg.addEventListener('pointercancel', endDrag);
  svg.addEventListener('lostpointercapture', endDrag);

  svg.addEventListener('keydown', function (e) {
    var s = selected();
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'z') { e.preventDefault(); e.shiftKey ? redo() : undo(); return; }
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'y') { e.preventDefault(); redo(); return; }
    if (e.key === 'Tab' && !e.shiftKey && state.stamps.some(function (x) { return x.view === state.view; }) && !s) { /* allow tabbing out */ return; }
    if (e.key === 'n' || e.key === 'N') { cycleSelection(); e.preventDefault(); return; }
    if (!s) return;
    var v = viewById[s.view], lib = libById[s.ref], step = e.shiftKey ? 0.02 : 0.004, handled = true;
    switch (e.key) {
      case 'ArrowLeft': s.x = Math.max(0, s.x - step); break;
      case 'ArrowRight': s.x = Math.min(1, s.x + step); break;
      case 'ArrowUp': s.y = Math.max(0, s.y - step * v.w / v.h); break;
      case 'ArrowDown': s.y = Math.min(1, s.y + step * v.w / v.h); break;
      case '+': case '=': s.sizeIn = clampSize(lib, s.sizeIn + 0.01); break;
      case '-': case '_': s.sizeIn = clampSize(lib, s.sizeIn - 0.01); break;
      case ']': if (lib.rotatable) s.rot = (s.rot || 0) + 5; break;
      case '[': if (lib.rotatable) s.rot = (s.rot || 0) - 5; break;
      case 'Delete': case 'Backspace': removeSelected(); return;
      case 'Escape': state.selected = null; renderAll(); return;
      default: handled = false;
    }
    if (handled) { e.preventDefault(); commit(); }
  });
  function cycleSelection() {
    var on = state.stamps.filter(function (x) { return x.view === state.view; });
    if (!on.length) return;
    var i = on.findIndex(function (x) { return x.uid === state.selected; });
    state.selected = on[(i + 1) % on.length].uid; renderAll(); announce(stampLabel(selected()) + ' selected');
  }

  /* re-render handles at constant screen size when the stage resizes */
  if (window.ResizeObserver) new ResizeObserver(function () { schedule(); }).observe(stage);

  /* ---------- controls ---------- */
  function on(sel, evt, fn) { $all(sel).forEach(function (n) { n.addEventListener(evt, fn); }); }
  on('[data-ccp-head]', 'click', function (e) { state.head = e.currentTarget.getAttribute('data-ccp-head'); persist(); renderAll(); });
  on('[data-ccp-shaft]', 'click', function (e) { state.shaft = e.currentTarget.getAttribute('data-ccp-shaft'); persist(); renderAll(); });
  on('[data-ccp-length]', 'click', function (e) { state.length = parseFloat(e.currentTarget.getAttribute('data-ccp-length')); persist(); renderAll(); });
  on('[data-ccp-length-select]', 'change', function (e) { state.length = e.target.value === '' ? null : parseFloat(e.target.value); persist(); renderAll(); });
  on('[data-ccp-view]', 'click', function (e) { state.view = e.currentTarget.getAttribute('data-ccp-view'); var s = selected(); if (s && s.view !== state.view) state.selected = null; persist(); renderAll(); });
  on('[data-ccp-undo]', 'click', undo);
  on('[data-ccp-redo]', 'click', redo);
  on('[data-ccp-dup]', 'click', duplicateSelected);
  on('[data-ccp-del]', 'click', removeSelected);
  on('[data-ccp-front]', 'click', bringToFront);
  on('[data-ccp-back]', 'click', sendToBack);
  on('[data-ccp-preview]', 'click', function () { state.preview = !state.preview; if (state.preview) state.selected = null; renderAll(); });
  on('[data-ccp-zones]', 'click', function () { state.showZones = !state.showZones; renderAll(); });
  var resetArmed = null;
  on('[data-ccp-reset]', 'click', function (e) {
    var b = e.currentTarget;
    if (!resetArmed) { b.textContent = 'Confirm reset'; b.classList.add('is-armed'); resetArmed = setTimeout(function () { b.textContent = 'Reset'; b.classList.remove('is-armed'); resetArmed = null; }, 3500); return; }
    clearTimeout(resetArmed); resetArmed = null; b.textContent = 'Reset'; b.classList.remove('is-armed');
    state.stamps = []; state.selected = null; commit(); announce('All stamps removed. Use Undo to bring them back.');
  });
  on('[data-ccp-sel-size]', 'input', function (e) { var s = selected(); if (!s) return; s.sizeIn = clampSize(libById[s.ref], parseFloat(e.target.value)); validate(s); schedule(); });
  on('[data-ccp-sel-size]', 'change', commit);
  on('[data-ccp-sel-rot]', 'input', function (e) { var s = selected(); if (!s) return; s.rot = parseFloat(e.target.value); validate(s); schedule(); });
  on('[data-ccp-sel-rot]', 'change', commit);
  on('[data-ccp-sel-text]', 'input', function (e) {
    var s = selected(); if (!s) return; var lib = libById[s.ref];
    var clean = e.target.value.toUpperCase().replace(/[^A-Z0-9 ]/g, '').slice(0, lib.maxChars);
    if (clean !== e.target.value) { var pos = e.target.selectionStart; e.target.value = clean; try { e.target.setSelectionRange(pos, pos); } catch (er) { } }
    s.text = clean; validate(s); schedule(); renderList(); renderSummary();
  });
  on('[data-ccp-sel-text]', 'change', commit);
  on('[data-ccp-sel-set]', 'change', function (e) {
    var s = selected(); if (!s) return; var lib = libById[e.target.value]; if (!lib) return;
    s.ref = lib.id; s.sizeIn = lib.defaultIn; s.text = (s.text || '').slice(0, lib.maxChars); commit();
  });

  /* ---------- design export ---------- */
  function buildConfig() {
    var p = core.price(data, state);
    var stamps = state.stamps.map(function (s, i) {
      var g = geom(s), lib = libById[s.ref];
      return {
        uid: s.uid, kind: lib.kind, stampId: lib.id, name: lib.name, imageRef: lib.kind === 'icon' ? lib.file : null,
        text: lib.kind === 'text' ? s.text : null, letterSet: lib.kind === 'text' ? lib.id : null,
        view: s.view, zone: s.zone, x: +s.x.toFixed(5), y: +s.y.toFixed(5),
        widthNorm: +(g.w / g.view.w).toFixed(5), heightNorm: +(g.h / g.view.h).toFixed(5),
        widthIn: +(g.w / g.view.ppi).toFixed(4), heightIn: +s.sizeIn.toFixed(4), color: stampColor(s).name, colorHex: stampColor(s).hex, rotationDeg: Math.round(s.rot || 0), layer: i + 1
      };
    });
    var body = {
      version: CONFIG_VERSION,
      product: { handle: data.product.handle, variantId: p ? p.variant.id : null },
      head: state.head, shaft: state.shaft, shaftLengthIn: state.length,
      stamps: stamps,
      views: data.views.reduce(function (acc, v) { acc[v.id] = { label: v.label, image: v.file, imageWidth: v.w, imageHeight: v.h, pxPerInch: v.ppi }; return acc; }, {}),
      pricing: p ? { currency: data.currency, baseCents: p.baseCents, shaftSurchargeCents: p.shaftSurchargeCents, stampSurchargeCents: p.stampSurchargeCents, totalCents: p.totalCents } : null
    };
    var id = 'CC-' + core.hash(JSON.stringify(body));
    body.configId = id;
    body.createdAt = new Date().toISOString();
    return body;
  }

  function stampsSummaryText(cfg) {
    if (!cfg.stamps.length) return 'None';
    return cfg.stamps.map(function (s) {
      var label = s.kind === 'text' ? '"' + s.text + '" (' + s.name + ')' : s.name;
      return label + ' (' + (s.color || 'White') + ') – ' + cfg.views[s.view].label + (s.zone ? ' ' + zoneName(s.view, s.zone) : '') + ', ' + core.mm(s.heightIn) + (s.rotationDeg ? ', ' + s.rotationDeg + '°' : '');
    }).join('; ');
  }
  function zoneName(viewId, zoneId) { var z = (viewById[viewId].zones || []).filter(function (z) { return z.id === zoneId; })[0]; return z ? z.name : zoneId; }

  /* ---------- flattened preview (canvas) ---------- */
  function loadImg(src) {
    return new Promise(function (res, rej) { var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { res(i); }; i.onerror = rej; i.src = src; });
  }
  function drawStamp(ctx, st, scale) {
    var g = geom(st); var lib = g.lib;
    var w = g.w * scale, h = g.h * scale;
    var off = document.createElement('canvas'); off.width = Math.ceil(w + 4); off.height = Math.ceil(h + 4);
    var o = off.getContext('2d');
    var p = Promise.resolve();
    if (lib.kind === 'icon') {
      p = loadImg(lib.src).then(function (im) { o.drawImage(im, 2, 2, w, h); });
    } else {
      var fs = h / data.fonts.capRatio;
      o.font = fontWeightFor(lib) + ' ' + fs + 'px ' + fontFor(lib);
      o.textAlign = 'center'; o.textBaseline = 'alphabetic';
      if ('letterSpacing' in o) o.letterSpacing = (fs * 0.06) + 'px';
      o.fillStyle = '#000'; o.fillText(st.text || '', off.width / 2, 2 + h);
    }
    return p.then(function () {
      // highlight copy (white) for the subtle stamped-edge effect
      var hl = document.createElement('canvas'); hl.width = off.width; hl.height = off.height;
      var h2 = hl.getContext('2d'); h2.drawImage(off, 0, 0); h2.globalCompositeOperation = 'source-in';
      var col = stampColor(st);
      h2.fillStyle = isDark(col.hex) ? 'rgba(255,255,255,0.35)' : 'rgba(0,0,0,0.5)'; h2.fillRect(0, 0, hl.width, hl.height);
      o.globalCompositeOperation = 'source-in';
      o.fillStyle = 'rgba(' + hexRgb(col.hex).join(',') + ',' + data.settings.opacity + ')'; o.fillRect(0, 0, off.width, off.height);
      ctx.save();
      ctx.translate(g.cx * scale, g.cy * scale); ctx.rotate((st.rot || 0) * Math.PI / 180);
      if (data.settings.engrave) ctx.drawImage(hl, -off.width / 2, -off.height / 2 + Math.max(1, g.view.ppi * 0.0045) * scale);
      ctx.drawImage(off, -off.width / 2, -off.height / 2);
      ctx.restore();
    });
  }
  function renderViewPng(view, maxW) {
    var scale = Math.min(1, (maxW || view.w) / view.w);
    var c = document.createElement('canvas'); c.width = Math.round(view.w * scale); c.height = Math.round(view.h * scale);
    var ctx = c.getContext('2d');
    return loadImg(view.full || view.src).then(function (im) {
      ctx.drawImage(im, 0, 0, c.width, c.height);
      var list = state.stamps.filter(function (s) { return s.view === view.id; });
      return list.reduce(function (pr, s) { return pr.then(function () { return drawStamp(ctx, s, scale); }); }, Promise.resolve());
    }).then(function () { return c; });
  }
  function renderSheet(maxW) {
    var cfg = buildConfig();
    var views = data.views.filter(function (v) { return state.stamps.some(function (s) { return s.view === v.id; }); });
    if (!views.length) views = data.views.slice(0, 1);
    return Promise.all(views.map(function (v) { return renderViewPng(v, maxW); })).then(function (canvases) {
      var W = Math.max.apply(null, canvases.map(function (c) { return c.width; }));
      var lines = ['California Classic Custom Putter — ' + cfg.configId, state.head + ' · ' + state.shaft + ' shaft · ' + (state.length ? core.fmtLength(state.length) : 'length not selected'), 'Stamps: ' + stampsSummaryText(cfg)];
      var lh = Math.round(W / 50), headerH = lh * (lines.length + 1);
      var H = canvases.reduce(function (a, c) { return a + c.height; }, 0) + headerH;
      var out = document.createElement('canvas'); out.width = W; out.height = H;
      var ctx = out.getContext('2d'); ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, W, H);
      ctx.fillStyle = '#111'; ctx.font = Math.round(lh * 0.62) + 'px Helvetica, Arial, sans-serif';
      lines.forEach(function (l, i) { wrapText(ctx, l, lh * 0.5, lh * (i + 1), W - lh); });
      var y = headerH; canvases.forEach(function (c) { ctx.drawImage(c, 0, y); y += c.height; });
      return out;
    });
  }
  function wrapText(ctx, text, x, y, maxW) {
    if (ctx.measureText(text).width <= maxW) { ctx.fillText(text, x, y); return; }
    while (text.length && ctx.measureText(text + '…').width > maxW) text = text.slice(0, -1);
    ctx.fillText(text + '…', x, y);
  }
  function download(canvas, name) {
    try {
      canvas.toBlob(function (b) {
        if (!b) { toast('Preview could not be created in this browser.'); return; }
        var a = document.createElement('a'); a.href = URL.createObjectURL(b); a.download = name; document.body.appendChild(a); a.click();
        setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1500);
      }, 'image/png');
    } catch (e) { toast('Preview could not be created in this browser.'); }
  }
  on('[data-ccp-download]', 'click', function (e) {
    var b = e.currentTarget; b.setAttribute('aria-busy', 'true');
    renderSheet(e.currentTarget.hasAttribute('data-ccp-hires') ? null : 1600).then(function (c) { download(c, buildConfig().configId + '.png'); })
      .catch(function () { toast('Preview could not be created. Please try again.'); })
      .finally(function () { b.removeAttribute('aria-busy'); });
  });

  /* final clean preview thumbnails in the review section */
  var reviewTimer = null;
  function renderReviewPreview() {
    clearTimeout(reviewTimer);
    reviewTimer = setTimeout(function () {
      var wrap = $('[data-ccp-review-images]'); if (!wrap) return;
      var views = data.views.filter(function (v) { return state.stamps.some(function (s) { return s.view === v.id; }); });
      if (!views.length) views = data.views.slice(0, 1);
      Promise.all(views.map(function (v) { return renderViewPng(v, 900).then(function (c) { return { v: v, c: c }; }); })).then(function (rs) {
        clear(wrap);
        rs.forEach(function (r) { var fig = document.createElement('figure'); r.c.setAttribute('role', 'img'); r.c.setAttribute('aria-label', r.v.label + ' view preview'); fig.appendChild(r.c); var cap = document.createElement('figcaption'); cap.textContent = r.v.label; fig.appendChild(cap); wrap.appendChild(fig); });
      }).catch(function () { /* preview optional */ });
    }, 350);
  }

  /* ---------- add to cart ---------- */
  function setBusy(b) { $all('[data-ccp-add]').forEach(function (n) { n.classList.toggle('is-busy', b); n.setAttribute('aria-busy', b); }); }
  on('[data-ccp-add]', 'click', function () {
    var iss = issues();
    if (iss.length) {
      toast(iss[0].msg);
      var t = $(iss[0].target);
      if (iss[0].uid) { var s = findStamp(iss[0].uid); state.selected = s.uid; state.view = s.view; state.preview = false; renderAll(); }
      if (t) { t.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'center' }); t.classList.add('is-flagged'); setTimeout(function () { t.classList.remove('is-flagged'); }, 1600); }
      return;
    }
    var cfg = buildConfig();
    var json;
    try { json = JSON.stringify(cfg); JSON.parse(json); } catch (e) { toast('Your design could not be saved. Please try again.'); return; }
    var p = core.price(data, state);
    var props = {
      'Shaft Length': core.fmtLength(state.length),
      'Stamps': stampsSummaryText(cfg),
      'Design ID': cfg.configId,
      '_design': json
    };
    setBusy(true);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: p.variant.id, quantity: 1, properties: props }] }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
        var item = res.j.items ? res.j.items[0] : res.j;
        if (item && item.price !== p.totalCents) toast('Note: cart price ' + core.formatMoney(item.price, data.moneyFormat) + ' differs from the configured price. Shopify’s price applies.');
        try { localStorage.setItem(STORE_KEY + ':last', json); } catch (e) { }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $all('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; n.hidden = cart.item_count === 0; });
        $all('[data-cart-subtotal]').forEach(function (n) { n.textContent = core.formatMoney(cart.total_price, data.moneyFormat); });
        if (window.Auric && window.Auric.refreshCartDrawer) window.Auric.refreshCartDrawer();
        var opener = document.querySelector('[data-drawer-open="cart"]');
        setTimeout(function () { if (opener) opener.click(); }, 250);
        toast('Your custom putter (' + cfg.configId + ') was added to your cart');
        var done = $('[data-ccp-added]'); if (done) { done.hidden = false; done.querySelector('[data-ccp-added-id]').textContent = cfg.configId; }
      })
      .catch(function (err) { toast(err.message || 'Something went wrong. Please try again.'); })
      .finally(function () { setBusy(false); });
  });

  /* ---------- owner design review (#review) ---------- */
  function initReview() {
    var panel = $('[data-ccp-review-panel]'); if (!panel) return;
    function check() { panel.hidden = location.hash.indexOf('#review') !== 0; }
    window.addEventListener('hashchange', check); check();
    on('[data-ccp-review-load]', 'click', function () {
      var txt = $('[data-ccp-review-input]').value.trim();
      var msg = $('[data-ccp-review-msg]');
      try {
        var cfg = JSON.parse(txt);
        if (!cfg || !Array.isArray(cfg.stamps)) throw new Error('No stamps found in this design');
        if (data.headOptions.indexOf(cfg.head) > -1) state.head = cfg.head;
        if (data.shaftOptions.indexOf(cfg.shaft) > -1) state.shaft = cfg.shaft;
        state.length = lengths.indexOf(cfg.shaftLengthIn) > -1 ? cfg.shaftLengthIn : null;
        var missing = 0;
        state.stamps = cfg.stamps.map(function (s) {
          var ref = s.kind === 'text' ? s.letterSet : s.stampId;
          if (!libById[ref] || !viewById[s.view]) { missing++; return null; }
          return { uid: uid(), ref: ref, view: s.view, x: s.x, y: s.y, sizeIn: s.heightIn, rot: s.rotationDeg || 0, text: s.text || undefined, color: colorByName[s.color] ? s.color : 'White' };
        }).filter(Boolean);
        state.selected = null; state.preview = true; commit();
        msg.textContent = 'Loaded ' + (cfg.configId || 'design') + ' · ' + state.stamps.length + ' stamps' + (missing ? ' · ' + missing + ' stamp(s) reference artwork no longer in the library' : '');
        msg.classList.toggle('is-error', !!missing);
      } catch (e) { msg.textContent = 'Could not read that design: ' + e.message; msg.classList.add('is-error'); }
    });
  }

  function prefersReduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* ---------- mobile sticky bar ---------- */
  function initSticky() {
    var bar = $('[data-ccp-sticky]'); var main = $('[data-ccp-main-add]'); if (!bar || !main || !window.IntersectionObserver) return;
    new IntersectionObserver(function (es) { bar.classList.toggle('is-visible', !es[0].isIntersecting); }, { threshold: 0 }).observe(main);
  }

  /* ---------- start ---------- */
  (function () {
    var f = svg.querySelector('#ccp-engrave'); if (!f) return;
    COLORS.forEach(function (cc, i) {
      var nf = f.cloneNode(true); nf.setAttribute('id', 'ccp-ink-' + i);
      var c = hexRgb(cc[1]).map(function (n) { return (n / 255).toFixed(3); });
      var ink = nf.querySelector('[result="ink"]'); if (ink) ink.setAttribute('values', '0 0 0 0 ' + c[0] + '  0 0 0 0 ' + c[1] + '  0 0 0 0 ' + c[2] + '  0 0 0 1 0');
      var hv = isDark(cc[1]) ? 1 : 0, ha = data.settings.engrave ? (hv ? 0.35 : 0.55) : 0;
      var hl = nf.querySelector('[result="hl"]'); if (hl) hl.setAttribute('values', '0 0 0 0 ' + hv + '  0 0 0 0 ' + hv + '  0 0 0 0 ' + hv + '  0 0 0 ' + ha + ' 0');
      f.parentNode.appendChild(nf);
    });
  })();
  (function () {
    var ctr = $('.ccp-sel__controls'); if (!ctr) return;
    var fld = document.createElement('div'); fld.className = 'ccp-field ccp-field--color';
    var lab = document.createElement('span'); lab.className = 'ccp-field__label'; lab.id = 'ccp-color-label-' + (root.id || 'x');
    lab.innerHTML = 'Color <span class="ccp-muted" data-ccp-sel-color-out></span>';
    var grp = document.createElement('div'); grp.className = 'ccp-colors'; grp.setAttribute('role', 'radiogroup'); grp.setAttribute('aria-labelledby', lab.id);
    COLORS.forEach(function (cc) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'ccp-color'; b.setAttribute('role', 'radio'); b.setAttribute('data-ccp-color', cc[0]);
      b.setAttribute('aria-label', cc[0]); b.title = cc[0]; b.style.background = cc[1];
      b.addEventListener('click', function () { var s = selected(); state.color = cc[0]; if (s) { s.color = cc[0]; commit(); announce(cc[0] + ' selected'); } else persist(); renderAll(); });
      grp.appendChild(b);
    });
    grp.addEventListener('keydown', function (e) {
      var k = e.key; if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(k) < 0) return; e.preventDefault();
      var i = colorByName[stampColor(selected()).name].i, n = (i + (k === 'ArrowRight' || k === 'ArrowDown' ? 1 : -1) + COLORS.length) % COLORS.length;
      var nb = grp.querySelectorAll('[data-ccp-color]')[n]; nb.click(); nb.focus();
    });
    fld.appendChild(lab); fld.appendChild(grp); ctr.insertBefore(fld, ctr.firstChild);
  })();
  try { var stl = document.createElement('style'); stl.textContent = '.ccp-tile__art{height:64px;background:#1c1c1c;border-radius:2px}.ccp-view__extra{font-size:.62rem;letter-spacing:.04em;text-transform:none;color:var(--ccp-muted)}.ccp-field--color{grid-column:1/-1}.ccp-field__label{display:block;font-size:.72rem;letter-spacing:.12em;text-transform:uppercase;margin-bottom:8px}.ccp-colors{display:flex;flex-wrap:wrap;gap:10px}.ccp-color{width:30px;height:30px;border-radius:50%;padding:0;border:1px solid rgba(0,0,0,.3);box-shadow:inset 0 0 0 2px rgba(255,255,255,.85);cursor:pointer;transition:transform .15s}.ccp-color:hover{transform:scale(1.08)}.ccp-color[aria-checked=true]{outline:2px solid #111;outline-offset:3px}.ccp-color:focus-visible{outline:2px solid #111;outline-offset:3px}'; document.head.appendChild(stl); } catch (e) { }
  data.variantsReady = false;
  fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + data.product.handle + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { if (!r.ok) throw new Error('http'); return r.json(); })
    .then(function (p) {
      data.product.variants = p.variants.map(function (v) { return { id: v.id, option1: v.option1, option2: v.option2, option3: v.option3, price: v.price, available: v.available }; });
      data.extraOptions = (p.options && p.options[2] && p.options[2].values) || [];
    })
    .catch(function () { data.variantsFailed = true; })
    .then(function () { data.variantsReady = true; renderAll(); });
  if (!data.views.length) { $('[data-ccp-noimages]').hidden = false; }
  loadPersisted();
  buildLibrary();
  validateAll();
  lastSnap = snapshot();
  initReview();
  initSticky();
  var origRenderAll = renderAll;
  renderAll = function () { origRenderAll(); renderReviewPreview(); };
  renderAll();
  // Re-measure text stamps once the stamp fonts have loaded
  if (document.fonts && document.fonts.ready) {
    var fams = [data.fonts.standardWeight + ' 40px ' + data.fonts.standard, data.fonts.largeWeight + ' 40px ' + data.fonts.large];
    Promise.all(fams.map(function (f) { return document.fonts.load(f, 'ABC123'); })).then(function () { validateAll(); renderAll(); }).catch(function () { });
  }
  root.classList.add('is-ready');
  window.CCP.debug = { state: state, buildConfig: buildConfig, issues: issues, addStamp: addStamp, undo: undo, redo: redo, geom: geom };
})();
